import './new-quote-transport.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormQuoteTransport from "../form-quote-transport/form-quote-transport";
import { useNewQuoteTransport } from './new-quote-transport.hook';

export function NewQuoteTransport() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewQuoteTransport();

  return (
    <div id="NewQuoteTransport" className="quote-transport">
      <HeaderContent
        title={<h1>New Quote Transport</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormQuoteTransport />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewQuoteTransport;